import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { LabelMediumSemiBold } from '../../../../../primitives/index.js';
export const ValueWrapper = ({
  placeholder,
  value
}) => {
  if (value) {
    return _jsx(LabelMediumSemiBold, {
      children: value
    });
  } else if (!value && placeholder) {
    return _jsx(LabelMediumSemiBold, {
      color: "contentTertiary",
      children: placeholder
    });
  } else {
    return null;
  }
};